import isServer from './isServer';

export default isServer ? (global as any) : (window as any);
